<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-06-19 14:12:18
 * @LastEditors: 陈钊贤
 * @Description: 
 * @LastEditTime: 2020-06-20 10:51:40
--> 
<template>
  <section class="pi-card "
           :class="type">
    <template v-if="type == 'primary'">
      <div class="pi-card-header">
        <div class="pi-card-title">{{title}}</div>
        <div class="card-header-right">
          <slot name="header-right"></slot>
        </div>
      </div>
      <div class="pi-card-content">
        <slot></slot>
      </div>
    </template>
    <template v-if="type == 'white'">
      <div class="white-card-header">
        <div class="white-card-title">{{title}}</div>
        <div class="white-header-right">
          <slot name="header-right"></slot>
        </div>
      </div>
      <div class="white-card-content">
        <slot></slot>
      </div>
    </template>
  </section>
</template>
<script>
export default {
  name: "pi-card",
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "primary"
    }
  }
};
</script>
<style lang="less">
.pi-card {
  margin-bottom: 0.2rem;
}
.pi-card.primary {
  .pi-card-header {
    border-radius: 0.12rem 0.12rem 0px 0px;
    background-color: rgba(0, 216, 127, 0.2);
    display: flex;
    padding: 0.1rem 0.20rem;
    .pi-card-title {
      flex: 1;
      font-size: 0.28rem;
      line-height: 0.4rem;
      color: #333;
      font-weight: 500;
    }
  }
  .pi-card-content {
    background-color: #fff;
    border-radius: 0px 0px 0.12rem 0.12rem;
  }
}
.pi-card.white {
  // padding: 0.2rem;
  background-color: #fff;
  border-radius: 0.12rem;
  .white-card-header {
    margin: 0 0.2rem;
    padding: 0.23rem 0 0.1rem 0;
    display: flex;
    border-bottom: 0.01rem solid #eeeeee;
    .white-card-title {
      flex: 1;
      font-weight: 500;
      font-size: 0.3rem;
      line-height: 0.42rem;
      color: #333;
      font-weight: 500;
    }
    .white-header-right {
      font-size: 0.26rem;
      line-height: 0.37rem;
      color: #999999;
    }
  }
  .white-card-content {
    padding: 0 0.2rem;
  }
}
</style>